import React,{useEffect,useState} from 'react';
import { useNavigate } from 'react-router-dom';
import * as AuthVerify from '../../lib/common';

const Login = () => {
	const navigate = useNavigate();
	
    useEffect(() => {
		const logout = async() => {
			await AuthVerify.removeSession();
			navigate('/');
		}

		logout();
    }, []);

	return (
		<></>
	);
};

export default Login;